/**
 * Upload every file chosen from a multiple file input and return only the
 * successfully uploaded file metadata.  The API still receives one file per
 * request, while callers can present a single multi-select control.
 */
export const uploadSelectedFiles = async (fileList, uploadFile) => {
    const files = Array.from(fileList || []).filter(Boolean);

    const uploads = await Promise.all(files.map(async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await uploadFile(formData);
            if (!response?.status || !response?.result?.fileName) return null;

            return {
                fileName: response.result.fileName,
                originalFileName: response.result.originalFileName || file.name,
            };
        } catch {
            return null;
        }
    }));

    return uploads.filter(Boolean);
};
